import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { filter, tap } from 'rxjs/operators';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';

import { ApiService, AuthService, LabsService, HraService, NotificationService, ProfileService} from '@app/services';
import { bind } from 'lodash-decorators/bind';
import { theme } from '@theme/.';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  animations: [
    trigger('slide', [
      transition(':enter', [
        style({opacity: 0, right: '-100%', position: 'absolute'}),
        animate('0.5s ease-out', style({opacity: 1, right: '0%'}))
      ]),
      transition(':leave', [
        style({opacity: 1, right: '0%', position: 'absolute'}),
        animate('0.5s ease-in', style({opacity: 0, right: '-100%'}))
      ]),
    ])
  ]
})

export class NavbarComponent implements OnInit {
  @ViewChild('swal') swalTest: SwalComponent;
  @ViewChild('swalSMS') swalSMS: SwalComponent;

  showMenu = false;
  showNotificationPane = false;
  theme = theme;
  hraDismissed  = localStorage.getItem('newHRADissmiss') || 'false';
  smsDismissed  = localStorage.getItem('smsDismissed') || 'false';

  //Instead of adding an "if" statment that would slowly affect multiple platforms wheather it would be on a black list or a white list
  black_list = ["LabInfo","MisResultados"];

  loggedIn = false;
  message: string;
  name: string;
  hraCompleted = false;
  hasResults = false;
  hasHealthplans = false;
  isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

  parameters:any = [];

  constructor(private route: ActivatedRoute, private auth: AuthService, private router: Router, private hra: HraService, private API: ApiService,
              public labs: LabsService, public notifications: NotificationService, public profile: ProfileService) { }

  ngOnInit() {

    this.auth.isLoggedIn$.pipe(
      tap(status => this.loggedIn = status),
    ).subscribe();

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart)
    ).subscribe(() => {
        if (this.loggedIn) {

          this.getSmsParams();
          this.API.new_hra_api.answers(0, 1).subscribe((response: any) => {
            response.results.forEach((item) => {
              if (item.completed == true) {
                this.hasResults = true;
              }
            })
          })
        }

      (document.activeElement as HTMLElement).blur();
      this.onSetHamburger(false);
      this.onToggleNotifications(false);
    });

    this.auth.checkUpdate$.subscribe((status) => {
      status ? this.getUserInfo() : this.clearUserInfo();
    });
  }

  // prepareRoute(outlet: RouterOutlet) {
  //   return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  // }

  //  checks if sms_notify parameter is received.  If received it will display an alert,
  //  once user clicks OK or 'x' it  wont be displayed again.
  //  returns: nothing
  getSmsParams() {

    this.route.queryParamMap
    .subscribe((params) => {
      this.parameters = { ...params.keys, ...params };  // get parameters object
        if (this.parameters.params.sms_notify == '1') {    // verify if sms_notify was received with value 1
          if (this.smsDismissed == 'false') {
              // console.info(this.parameters.params)
              this.swalSMS.fire()   // show the toast alert
          }
        }
    });
  }

  // TODO: none of this should be happening in the navbar component
  getUserInfo() {
    const {databases, has_completed_hra} = this.auth.getPayload();
    const {first_name} = this.profile.getValue();

    let allDatabases = databases;
    if (!Array.isArray(databases)) {
      allDatabases = Object.values(databases).flat() as string[];
      allDatabases = Array.from(new Set(allDatabases)); // remove duplicates
    }
    allDatabases = allDatabases.filter(db => db != "default")
    this.name = first_name;
    this.hraCompleted = has_completed_hra;
    this.hasHealthplans = allDatabases?.length > 0;

    if (this.hraCompleted == false && this.hraDismissed == "false") {
      console.log("this.hraDismissed", this.hraDismissed);

      setTimeout(() => {
        this.swalTest.fire()
      }, 1000);
    }
  }

  goToHra(){
    localStorage.setItem('newHRADissmiss', 'true');
    this.router.navigate(['/hra']);
  }

  handleDismiss(){
    localStorage.setItem('newHRADissmiss', 'true');
  }

  //  store iwhether modal was dismissed after user clicks OK and navigate to SMS Settings form
  //  returns: nothing
  goToSMS() {
    localStorage.setItem('smsDismissed', 'true');
    this.router.navigate(['/privacy_settings/sms-notifications']);
  }

  //  store whether modal was dismissed after user clicks 'X'
  //  returns: nothing
  handleSMSDismiss(){
    localStorage.setItem('smsDismissed', 'true');
  }

  clearUserInfo() {
    this.name = null;
    this.hraCompleted = false;
    this.hasHealthplans = false;
  }

  onLogout() {
    this.auth.logout().subscribe();
  }

  onSetHamburger(state: boolean, event?) {
    this.showMenu = state;
    this.showNotificationPane = false;
    document.body.classList[state ? 'add' : 'remove']('no-overflow');

    window[state ? 'addEventListener' : 'removeEventListener']
      ('click', this.outsideClickListener);
  }

  onToggleNotifications(state: boolean, event?) {
    this.showNotificationPane = state;
    this.showMenu = false;
    document.body.classList[state ? 'add' : 'remove']('no-overflow');

    if (state) {
      this.notifications.markAllAs({ seen: true });
    } else if (event) {
      this.notifications.markAllAs({ read: true });
    }

    window[state ? 'addEventListener' : 'removeEventListener']
      ('click', this.outsideNotificationListener);
  }

  onReportProblem() {
    this.router.navigate(['/contactUs']);
  }

  // close mobile hamburger menu when clicked outside of, also excludes navbar
  @bind()
  outsideClickListener() {
    const target = event.target as Node;
    const containers = Array.from(document.querySelectorAll('.right-section, .icon-hamburger'));
    if (containers && !containers.find(container => container.contains(target))) {
      this.showMenu = false;
      window.removeEventListener('click', this.outsideClickListener);
      document.body.classList.remove('no-overflow');
    }
  }

  @bind()
  outsideNotificationListener(event) {
    const target = event.target as Node;
    const containers = Array.from(document.querySelectorAll('app-notification-pane'));
    if (containers && !containers.find(container => container.contains(target))) {
      this.showNotificationPane = false;
      window.removeEventListener('click', this.outsideNotificationListener);
      this.notifications.markAllAs({ read: true });
      document.body.classList.remove('no-overflow');
    }
  }
}
